import { useContext, useState } from "react";
import { SystemMessageContext } from "../../context/SystemMessageContext";
import callAPI from "../../helpers/callAPI";
import { useAuth, useProtectedContent } from "../../context/AuthContext";

const StatusSelect = ({ status, ratePitchId, closeModal, saveNeeded, advertiserId, data, refetch }) => {
    const { showSystemMessage } = useContext(SystemMessageContext)
    const auth = useAuth()
    const showCancel = useProtectedContent(auth.permissions, 'rate_pitch_cancel')
    const [confirmAction, setConfirmAction] = useState(null);
    

    const updatePitch = async (newStatus) => {
        if (saveNeeded) {
            showSystemMessage('error', 'Please save your changes before updating the status.')
            return
        }

        let rates = []
        data.pitch.campaignPitches.forEach(offer => {
            offer.rates.forEach(rate => {
                if (rate.proposedRate && rate.proposedRate.toString().trim() !== '') {
                    // Find the matching campaign and its rate
                    const campaign = data.pitch?.campaigns?.find(c => c.id === offer.id)
                    console.log('Matching campaign for offer', offer.id, campaign);
                    const existingRateObj = campaign?.rates?.find(r => r.name === rate.name) ?? null

                    rates.push({
                        id: rate.id,
                        offerId: offer.id,
                        offerName: offer.name,
                        affiliate: rate.affiliate,
                        affiliateId: rate.affiliateId,
                        name: rate.name,
                        proposedRate: rate.proposedRate.toString().trim(),
                        existingRate: existingRateObj?.net_rate ?? rate.originalNetRate ?? null,
                        net_rate_text: existingRateObj?.net_rate_text ?? (rate.originalNetRate ? `${rate.originalNetRate}` : 'N/A')
                    })
                }
            })
        })

        rates = rates.map((rate, idx) => {
            if (idx >= 2) return null;

            if (!rate.affiliateId) {
                return `Campaign level: ${rate.offerName} (${rate.offerId}) - Existing Rate: ${rate.net_rate_text} - Proposed Rate: ${rate.proposedRate}`
            } else {
                return `Affiliate level: ${rate.affiliate?.name ?? 'Unknown'} (${rate.affiliateId}) - Existing Rate: ${rate.net_rate_text} - Proposed Rate: ${rate.proposedRate}`
            }
        }).filter(Boolean)
        if (rates.length >= 2) {
            rates.push(`More items included in this Rate Pitch.`)
        }
        rates.push(`<a href="${process.env.REACT_APP_PORTAL_URL}/advertisers/ratePitch/${ratePitchId}" target="_blank">View Pitch</a>`)
        rates = rates.join('<br />')

        const response = await callAPI(`advertisers/ratepitch/${ratePitchId}/status/${newStatus}?`, 'PUT', {
            followupNote: rates,
            advertiserId: advertiserId,
            results: 'OT',

        })
        if (response.success) {
            if (closeModal) {
                closeModal();
            } else {
                refetch();
            }
        } else {
            showSystemMessage('error', response.message);
        }
    }

    const handleActionClick = (actionCode) => {
        if (confirmAction === actionCode) {
            updatePitch(actionCode);
            setConfirmAction(null);
        } else {
            setConfirmAction(actionCode);
        }
    };

    return (
        <div className="card mt-3">
            <div className="card-header">
                <h1 className="mb-h1-dark">Actions</h1>
            </div>
            <div className="card-body">
                {status.code === 'O' && (
                    <button className="btn btn-primary" onClick={() => handleActionClick('R')}>
                        {confirmAction === 'R' ? 'Confirm Submit for Review' : 'Submit for Review'}
                    </button>
                )}
                {status.code === 'R' && (
                    <>
                        <button className="btn btn-secondary" onClick={() => handleActionClick('O')}>
                            {confirmAction === 'O' ? 'Confirm Send Back to AAM' : '<- Send Back to AAM'}
                        </button>
                        <button className="btn btn-primary ml-2" onClick={() => handleActionClick('P')}>
                            {confirmAction === 'P' ? 'Confirm Approve Rate Pitch' : 'Approve Rate Pitch ->'}
                        </button>
                    </>
                )}
                {status.code === 'P' && (
                    <button className="btn btn-primary" onClick={() => handleActionClick('D')}>
                        {confirmAction === 'D' ? 'Confirm Approved by Advertiser' : 'Approved by Advertiser'}
                    </button>
                )}
                {status.code === 'D' && (
                    <>
                        <button className="btn btn-primary mr-2" onClick={() => handleActionClick('P')}>
                            {confirmAction === 'P' ? 'Confirm Send Back to Pending' : '<- Send Back to Pending'}
                        </button>
                        <button className="btn btn-primary" onClick={() => handleActionClick('A')}>
                            {confirmAction === 'A' ? 'Confirm Rates Updated' : 'Rates Updated'}
                        </button>
                    </>
                )}
                <br />
                <div className='mt-2'>
                    {showCancel && (status.code === 'O' || status.code === 'R') && (
                        <button className="btn btn-warning" onClick={() => handleActionClick('C')}>
                            {confirmAction === 'C' ? 'Confirm Denied by MaxBounty' : 'Denied by MaxBounty'}
                        </button>
                    )}
                    {status.code !== 'A' && status.code !== 'D' && (
                        <button className={`btn btn-danger ${showCancel && (status.code === 'O' || status.code === 'R') && 'ml-2'}`} onClick={() => handleActionClick('X')}>
                            {confirmAction === 'X' ? 'Confirm Denied by Advertiser' : 'Denied by Advertiser'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}
export default StatusSelect;